// src/RegisterOrganization.js

import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { ManageBranchService } from '../api/services';
const Recharge = () => {
  const [IsLoading, setIsLoading] = useState(false);
  const [values, setValues] = useState({ Admin: '', organization: '', branch: '', branchUser: '',recharge:'' });
  const [errors, setErrors] = useState({});
  const [redvalue, setredvalue] = useState("");
  const [adminDdl, setAdminDdl] = useState([]);
  const [orgDdl, setOrgDdl] = useState([]);
  const [branchDdl, setBranchDdl] = useState([]);
  const [branchUser, setBranchUserDdl] =useState([]);
  const [selectedbranchUserId, setselectedbranchUserId] = useState([]);
  const adminVal = useRef('');
  const orgVal = useRef('');
  const branchVal = useRef('');
  const [rechargeAmount, setrechargeAmount] = useState([]);
  const handleInput = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };


   function fnAdminddlChange(event) {

    adminVal.current = event.target.value;
    const adminId = adminVal.current;
    if (adminId != "" && adminId != "Select Admin") {
      var data = JSON.stringify({
        "admin_id": adminId,
      });
      const BASE_URL = window.BASE_URL + '/get_organizations';
      setIsLoading(true);
      var config = {
        method: 'post',
        url: BASE_URL,

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
        data: data
      };

      axios.request(config)
        .then((response) => {

          setOrgDdl([]);
          if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
            setOrgDdl(response.data.results);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    else {
      setOrgDdl([]);
    }
  }

  

  const navigate = useNavigate();

  function Validation(values) {
    const errors = {};
    let validationFlag = true;
    if (values.Admin === "") {
      errors.Admin = "Admin is required";
      errors.validationFlag = false;
    }
    if (values.organization === "") {
      errors.organization = "organization is required";
      errors.validationFlag = false;
    }
    if (values.branch === "") {
      errors.branch = "Branch is required";
      errors.validationflag = false;
    }
    if (values.branchUser === "") {
      errors.branchUser = "Branch User is required";
      errors.validationFlag = false;
    }
    if (values.recharge === "") {
      errors.recharge = "Recharge Amount is required";
      errors.validationFlag = false;
    }
    return errors;
  }
   function generateTransactionId() {
    const timestamp = Date.now(); // milliseconds since epoch
    const random = Math.floor(Math.random() * 10000); // 4-digit random number
    return `TRANS_${timestamp}_${random}`;
  }
  function handleSubmit(event) {
    debugger
    event.preventDefault();
    const errorMsg = Validation(values)
    setErrors(errorMsg);

    if (errorMsg.validationFlag == false) { return false; }
    const transactionId = generateTransactionId();
   const payLoad = {
      transaction_id: generateTransactionId(),
      transfer_to: selectedbranchUserId,
      amount: values.recharge,
      transaction_type: 'ADMIN'
      };


    ManageBranchService.addAdminRecharge(payLoad)
      .then((res) => {
        if (res.data.code === "201") {
          alert(res.data.error_message);
        } else {
          alert(res.data.results);
        }
        navigate("/Admin/AdminDashboard");
      })
      .catch((err) => {
        console.error('Failed to Recharge:', err);
      });
  }
  useEffect(() => {
    let TokenVal = localStorage.getItem('jwtToken');
    if (TokenVal === null || TokenVal === "" || TokenVal === undefined) {
      navigate("/");
    }

    fnAdminDdlLoad();
  }, []);

  function fnAdminDdlLoad() {
    const BASE_URL = window.BASE_URL + '/get_admins';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };

    axios.request(config)
      .then(function (response) {
        setAdminDdl([]);

        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
          setAdminDdl(response.data.results);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function fnAdminddlChange(event) {

    adminVal.current = event.target.value;
    const adminId = adminVal.current;
    if (adminId != "" && adminId != "Select Admin") {
      var data = JSON.stringify({
        "admin_id": adminId,
      });
      const BASE_URL = window.BASE_URL + '/get_organizations';
      setIsLoading(true);
      var config = {
        method: 'post',
        url: BASE_URL,

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
        data: data
      };

      axios.request(config)
        .then((response) => {

          setOrgDdl([]);
          if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
            setOrgDdl(response.data.results);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    else {
      setOrgDdl([]);
    }
  }

  function fnOrganizationChange(event) {
    orgVal.current = event.target.value;
    const orgId = orgVal.current;
    if (orgId != "" && orgId != "Select Organization") {
      var data = JSON.stringify({
        "organization_id": orgId,
      });
      const BASE_URL = window.BASE_URL + '/get_branches';
      setIsLoading(true);
      var config = {
        method: 'post',
        url: BASE_URL,

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
        data: data
      };

      axios.request(config)
        .then((response) => {

          setBranchDdl([]);
          if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
            setBranchDdl(response.data.results);
           
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    else {
      setBranchDdl([]);
    }
  }

  function fnBranchChange(event) {
    debugger
    branchVal.current = event.target.value;
    getUsersByBranchId();
  }

  // get users data 
  const getUsersByBranchId=()=>{
    const payload = {
      organization_id :orgVal.current,
      branch_id: parseInt(branchVal.current)
    }
    setIsLoading(true);
    ManageBranchService.getUsersByBranchId(payload)
    .then((res)=>{
      if (res.data.code === 200) {
        setBranchUserDdl(res.data.results);
      } else {
        setBranchUserDdl([]);
      }
      setIsLoading(false);
    }).catch((err) => {

      console.error('Failed to fetch title:', err)
        setIsLoading(false);
    });
    
  };

  return (
    <div className="container-fluid">
      {/* Loader */}
    <div className="loader" style={IsLoading ? {} : { display: 'none' }}>
        <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
           {/* Back Button */}
      <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="super-admin-container form-outer">
        <div className="super-admin-header mb-2">
          <h1>Recharge</h1>
        </div>
        <div className="p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label className="form-label">Recharge Type</label>
                  <input
                    type="text"   
                    className="form-control"
                    value="AGENT"
                    disabled
                    readOnly
                  />
              </div>

              </div>
              <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label class="form-label">Select Admin</label>
                  <select className="form-select" name="Admin" onChange={(e) => {
                      handleInput(e);
                      fnAdminddlChange(e);
                      }}>
                    <option>Select Admin</option>
                    {adminDdl.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {errors.Admin && <span className="span-error">{errors.Admin}</span>}
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label class="form-label">Select Organization</label>
                  <select className="form-select" name="organization"  onChange={(e) => {
                        handleInput(e);
                        fnOrganizationChange(e);
                        }}>
                    <option>Select Organization</option>
                    {orgDdl.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {errors.organization && <span className="span-error">{errors.organization}</span>}
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label class="form-label">Select Branch</label>
                  <select className="form-select" name="branch" onChange={(e) => {
                      handleInput(e);
                      fnBranchChange(e);
                    }}>
                    <option>Select Branch</option>
                    {branchDdl.map((p) => (
                      <option key={p.branch_id
                      } value={p.branch_id
                      }>
                        {p.branch_name}
                      </option>
                    ))}
                  </select>
                  {errors.branch && <span className="span-error">{errors.branch}</span>}
                </div>
              </div>
               <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label class="form-label">Select Branch User/Agent</label>
                  <select className="form-select" name="branchUser" 
                    onChange={(event) => {
                          setselectedbranchUserId(event.target.value);
                          setValues(prev => ({ ...prev, branchUser: event.target.value }));
                    }}
                    >
                    <option>Select Branch  User/Agent</option>
                    {branchUser.map((p) => (
                      <option key={p.user_id
                      } value={p.user_id
                      }>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {errors.branchUser && <span className="span-error">{errors.branchUser}</span>}
                </div>
              </div>
                <div className="col-md-4 col-12">
                <div className="mb-3">
                  <label class="form-label">Amount to Recharge</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="100"
                    name="recharge"
                    value={values.recharge}
                    onChange={handleInput}
                    
                   />
                  {errors.recharge && <span className="span-error">{errors.recharge}</span>}
                </div>
              </div>
              <div className="col-md-12 col-12 text-center my-3">
                <button type="submit" className="super-admin-button">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Recharge;
